import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row justify-between items-center mb-6 gap-4" }
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Filter:", -1)
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "relative w-full md:w-80 input-icon-right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search text-neutral-400" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col gap-3 mb-6"
}
const _hoisted_8 = { class: "flex flex-wrap gap-2" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "text-blue-500" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times text-xs" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-700 text-base font-semibold" }, "Menampilkan data sesuai kriteria", -1)

import { PropType } from 'vue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Calendar from 'primevue/calendar'


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBar',
  props: {
  filterDate: {
    type: Array as PropType<Date[]>,
    default: () => []
  },
  searchQuery: {
    type: String,
    default: ''
  },
  activeFilters: {
    type: Array as PropType<Array<{ id: string; category: string; value: any; label: string }>>,
    default: () => []
  }
},
  emits: ['update:filterDate', 'update:searchQuery', 'openFilter', 'search', 'removeFilter'],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Calendar), {
            modelValue: __props.filterDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:filterDate', $event))),
            selectionMode: "range",
            dateFormat: "dd/mm/yy",
            placeholder: "Tanggal",
            class: "w-56"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(InputText), {
          modelValue: __props.searchQuery,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:searchQuery', $event))),
          placeholder: "Cari kode PP, nopol, atau kru",
          class: "w-full input-default",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('search')), ["enter"]))
        }, null, 8, ["modelValue"]),
        _hoisted_6
      ])
    ]),
    (__props.activeFilters.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.activeFilters, (pill) => {
              return (_openBlock(), _createElementBlock("div", {
                key: pill.id,
                class: "border border-blue-500 bg-blue-50 hover:bg-blue-100 rounded-full px-4 py-2 text-sm flex items-center gap-2 font-medium cursor-pointer transition-colors duration-150 text-blue-500",
                onClick: ($event: any) => (_ctx.$emit('removeFilter', pill))
              }, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(pill.label), 1),
                _hoisted_11
              ], 8, _hoisted_9))
            }), 128))
          ]),
          _hoisted_12
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})